export default __webpack_public_path__ + "static/media/logo.a6b7872d.png";